import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../../shared/client/client';
import { ListLigneCommande } from '../../../shared/commande';
import { CommandeService } from '../../../shared/commande.service';

export interface DialogData {
  lod_ligne_commandes: ListLigneCommande[]
  commandeId: string
  currentClient: Client
}

@Component({
  selector: 'app-besoin-validate-dialog',
  templateUrl: './besoin-validate-dialog.component.html',
  styleUrls: ['./besoin-validate-dialog.component.scss']
})
export class BesoinValidateDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<BesoinValidateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private commandeService: CommandeService
  ) { }

  validate() {
    this.commandeService.validateInventaires(this.data.commandeId).subscribe(data => {
      this.dialogRef.close(data)
    })
  }

  refuse(): void {
    this.dialogRef.close();
  }
}